import { Checkbox as HeadlessCheckbox } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';

export interface CheckboxProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'checked' | 'onChange'
  > {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel: string;
  className?: string;
  disabled?: boolean;
  indeterminate?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  className = '',
  disabled = false,
  ariaLabel,
  indeterminate = false,
  ...rest
}) => {
  return (
    <HeadlessCheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        checked || indeterminate
          ? 'bg-primary border-transparent'
          : 'bg-neutral-0 border-neutral-200',
        'relative inline-flex h-5 w-5 items-center justify-center rounded border-2 transition-colors duration-200 ease-in-out focus:outline-none',
        !disabled && 'cursor-pointer',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
      aria-label={ariaLabel}
      {...rest}
    >
      <span
        className={clsx(
          'pointer-events-none absolute h-3 w-3 transform transition-opacity duration-200 ease-in-out',
          checked || indeterminate ? 'opacity-100' : 'opacity-0',
        )}
      >
        {indeterminate ? (
          <svg
            className="h-3 w-3 text-neutral-0"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M3 6h6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            className="h-3 w-3 text-neutral-0"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M3 6l2 2 4-4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </HeadlessCheckbox>
  );
};

export default Checkbox;
